import { getBlatt, type PortalBlatt, type PortalSession, type PortalSessionId } from '../../api/portal'
import {
  BLATT_IDS,
  SHEETS,
  firstIncompleteIndex,
  isBlattComplete,
  statusesFrom,
  type BlattId,
  type BlattStatus,
  type Daten,
} from '../../lib/teilnehmerakte'

export type LoadedSession = {
  statuses: Record<BlattId, BlattStatus>
  blaetter: Partial<Record<BlattId, PortalBlatt>>
  retained?: Partial<Record<BlattId, Daten>>
  resume: number | null
  anyComplete: boolean
}

export async function loadSession(
  session: Pick<PortalSession, 'blaetter'>,
  sessionId: PortalSessionId,
  retained: Partial<Record<BlattId, Daten>>,
): Promise<LoadedSession> {
  const statuses = statusesFrom(session.blaetter)
  const blaetter: Partial<Record<BlattId, PortalBlatt>> = {}
  const fieldSheets = BLATT_IDS.filter((id) => SHEETS[id].kind !== 'sign' && statuses[id] !== 'offen')
  await Promise.all(
    fieldSheets.map(async (id) => {
      const fresh = await getBlatt(id, sessionId)
      if (fresh.status === 'unterschrieben') statuses[id] = fresh.status
      blaetter[id] = { ...fresh, daten: statuses[id] === 'unterschrieben' ? fresh.daten : retained[id] ?? fresh.daten }
    }),
  )
  const daten: Partial<Record<BlattId, Daten>> = {}
  for (const id of fieldSheets) daten[id] = blaetter[id]?.daten ?? {}
  const resume = firstIncompleteIndex(statuses, daten)
  const anyComplete = BLATT_IDS.some((id) => isBlattComplete(SHEETS[id], statuses[id], daten[id]))
  return { statuses, blaetter, retained, resume, anyComplete }
}
